import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';

export function Register() {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        registration_secret: '',
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (form.password !== form.password_confirmation) {
            setError('Le password non coincidono.');
            setLoading(false);
            return;
        }

        if (form.password.length < 8) {
            setError('La password deve essere di almeno 8 caratteri.');
            setLoading(false);
            return;
        }

        try {
            await api.register(form);
            navigate('/');
        } catch (err) {
            const message = err.response?.data?.message;
            if (typeof message === 'string') {
                setError(message);
            } else if (err.response?.data?.errors) {
                setError(Object.values(err.response.data.errors).flat().join(' '));
            } else {
                setError('Errore durante la registrazione.');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex bg-gray-50">
            <div className="hidden lg:flex w-1/2 bg-indigo-600 items-center justify-center p-12">
                <div className="text-white max-w-md">
                    <h1 className="text-4xl font-bold mb-4">Tascio Budget</h1>
                    <p className="text-indigo-100 text-lg">
                        Tieni sotto controllo entrate e spese in modo semplice e minimal.
                    </p>
                </div>
            </div>
            <div className="flex-1 flex items-center justify-center p-8">
                <div className="w-full max-w-sm">
                    <div className="mb-8 text-center lg:text-left">
                        <h2 className="text-2xl font-bold text-gray-900">Crea account</h2>
                        <p className="text-gray-500 text-sm mt-1">
                            Serve il codice di registrazione fornito dall'amministratore.
                        </p>
                    </div>
                    {error && (
                        <div className="mb-4 p-3 text-sm text-red-700 bg-red-50 rounded-lg">{error}</div>
                    )}
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Nome</label>
                            <input
                                type="text"
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 outline-none transition"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                            <input
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 outline-none transition"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                            <input
                                type="password"
                                name="password"
                                value={form.password}
                                onChange={handleChange}
                                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 outline-none transition"
                                required
                                minLength={8}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Conferma password</label>
                            <input
                                type="password"
                                name="password_confirmation"
                                value={form.password_confirmation}
                                onChange={handleChange}
                                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 outline-none transition"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Codice registrazione</label>
                            <input
                                type="text"
                                name="registration_secret"
                                value={form.registration_secret}
                                onChange={handleChange}
                                className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 outline-none transition"
                                required
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl font-medium transition disabled:opacity-60"
                        >
                            {loading ? 'Registrazione...' : 'Registrati'}
                        </button>
                    </form>
                    <p className="mt-6 text-center text-sm text-gray-500">
                        Hai già un account?{' '}
                        <Link to="/login" className="text-indigo-600 hover:underline">
                            Accedi
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
}
